
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { fetchMetadatas, warehouseSetupSelectDatabase, warehouseSetupChangeStep } from 'actions'
import ShowHide from 'ui/ShowHide'
import Alert from 'ui/Alert'
import Loader from 'ui/Loader'
import WarehouseMetadataSelector from '../../components/warehouse-metadata-selector'

class WarehouseSetupSelectContainer extends Component {
  render () {
    return (
      <div>
        <Loader isLoading={this.props.isRequesting}>
          <ShowHide show={this.props.didRequestFail}>
            <Alert type='danger'>
              <p>There was an error trying to request our supported database types. Please try again.</p>
            </Alert>
          </ShowHide>
          <WarehouseMetadataSelector
            list={this.props.list}
            databaseId={this.props.databaseId}
            onSelect={this.props.selectDatabase}
            onNext={this.props.next} />
        </Loader>
      </div>
    )
  }

  componentDidMount () {
    this.props.fetchWarehouseMetadata()
  }
}

function mapStateToProps (state) {
  // TODO: selectors
  const {
    isRequesting = true,
    didRequestFail,
    data = {}
  } = state.metadatasBySlug.warehouse

  const {
    databaseId
  } = state.application.warehouseSetup

  const list = []
  for (const slug in data) {
    list.push(data[slug].data)
  }

  return {
    // app
    databaseId,
    // data
    isRequesting,
    didRequestFail,
    list
  }
}

function mapDispatchToProps (dispatch) {
  return {
    fetchWarehouseMetadata: () => dispatch(fetchMetadatas({ metadataType: 'warehouse' })),
    selectDatabase: databaseId => dispatch(warehouseSetupSelectDatabase(databaseId)),
    next: () => dispatch(warehouseSetupChangeStep('connect'))
  }
}

WarehouseSetupSelectContainer.propTypes = {
  databaseId: PropTypes.string.isRequired,
  didRequestFail: PropTypes.bool,
  fetchWarehouseMetadata: PropTypes.func.isRequired,
  isRequesting: PropTypes.bool.isRequired,
  list: PropTypes.array.isRequired,
  next: PropTypes.func.isRequired,
  selectDatabase: PropTypes.func.isRequired
}

WarehouseSetupSelectContainer.displayName = 'WarehouseSetupSelectContainer'

export default connect(mapStateToProps, mapDispatchToProps)(WarehouseSetupSelectContainer)



// WEBPACK FOOTER //
// ./pages/workspace-warehouses/containers/warehouse-setup-select/index.js